<!-- ABOUT_ABOUT -->
<div class="about_card">
  alternative front end for ref dex smart contract,
  <br />
  and web app for huggies meme project
</div>
